import  request from "./service"

// api
export  const getIsRequireModal = (data)=>{
    return request({
        method:'post',
        url:"/api/user/checkUserPhoneAlert",
        data:data
    })
}
export const getMobileCode = (data) =>{
    return request({
        method:'post',
        url:"/api/user/sendPhoneMessage",
        data:data
    })
}
export const confirmChangePhoneNum = (data) => {
    return request({
        method: 'post',
        url: "/api/user/buildPhone",
        data: data
    })
}
export const getAutoLogin = () =>{
    return request({
        method:'post',
        url:"/autoGetUserToken",
        data: JSON.stringify({}),
    })
}
export const getUpgradePrice = (data) =>{
    return request({
        method: 'post',
        url: "/api/ShopDdns/getEndUserUpgradePriceStayExpireDate",
        data: data,
    })

}
export const confirmUpgrade = (data) =>{
    // /api/Shopddns / doAddUpgradeOrder
    return request({
        method: 'post',
        url: "/api/ShopDdns/doAddUpgradeOrder",
        data: data,
    })
}
export const gotoRenzheng = () =>{
    return request({
        method:'get',
        url:'/api/user/getGnwayLoginToUrl',
    })
}
export const addAddressFun = (data) =>{
    return request({
        method: 'post',
        url: '/api/UserAddr/addUserAddr',
        data:data,
    })

}


